(function () {
  // Sticky add-to-cart bar (mobile): show once the main button scrolls out of view
  var sticky = document.getElementById('sticky');
  var main = document.getElementById('addBtn');
  if (sticky && main) {
    var onScroll = function () {
      sticky.classList.toggle('show', main.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Product gallery thumbnails
  var stage = document.getElementById('stageImg');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!stage) return;
      stage.src = btn.getAttribute('data-src');
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  // Variant price update
  var sel = document.getElementById('variantSelect');
  var priceEl = document.getElementById('priceNow');
  if (sel && priceEl) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      priceEl.textContent = o.getAttribute('data-price');
    });
  }
})();
